import { combineReducers } from 'redux'

import currentTab from './currentTab'
import catalogSearch from './catalogSearch'
import catalogInlineSearch from './catalogInlineSearch'
import apidocsFromElastic from './apidocsFromElastic'
import providersFromAPI from './providersFromAPI'
import postRequestAPI from './postRequestAPI'
import categories from './categories'
import feedback from './feedback'
import intentProviders from './intentProviders'
import intentLanguages from './intentLanguages'
import getNews from './getNews'

const reducer = combineReducers({
    currentTab,
    catalogSearch,
    catalogInlineSearch,
    apidocsFromElastic,
    categories,
    feedback,
    providersFromAPI,
    postRequestAPI,
    intentProviders, // no description
    intentLanguages,
    getNews,
})

export default reducer



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/connectors/redux/reducers/index.js